import request from '@/axios'
import type { UserType, LoginResData } from './types'

const AUTH_PREFIX = '/auth-service/auth'

interface RoleParams {
  roleName: string
}

export const loginApi = (data: UserType): Promise<IResponse<LoginResData>> => {
  const response = request.post({
    url: `${AUTH_PREFIX}/login`,
    data: {
      username: data.username,
      password: data.password
    },
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Basic bWFsbC1hZG1pbi13ZWI6MTIzNDU2'
    }
  })
  return response
}

export const loginOutApi = (): Promise<IResponse> => {
  return request.post({ url: '/auth-service/auth/logout' })
}

export const getAdminRoleApi = (): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/user-service/menu/tree' })
}

export const getTestRoleApi = (params: RoleParams): Promise<IResponse<string[]>> => {
  return request.get({ url: '/mock/role/list2', params })
}

export const getUserInfoApi = (): Promise<IResponse> => {
  return request.get({ url: '/user/getUserById' })
}

export const refreshTokenApi = (refreshToken: string) => {
  return request.post({
    url: `${AUTH_PREFIX}/refresh`,
    data: { refreshToken },
    headers: { 'Content-Type': 'application/json' }
  })
}
